export const periodConstant = angular.module('periodConstant', [])
  .constant('period', {
    IN_PROGRESS: 'in_progress',
    TODAY: 'today',
    THIS_WEEK: 'this_week',
    NEXT_WEEK: 'next_week',
    ALL_TIMES: 'all_times'
  });



/** WEBPACK FOOTER **
 ** ./src/app/shared/constants/period.constant.js
 **/